<template>
	<tr>
		<td>
			<b-link
				href="#"
				@click.prevent="onUpdateClick"
			>{{ contract.Reference }}</b-link>
		</td>

		<td>{{ contract.Customer }} </td>

		<td><span
				v-for="(clock, index) in contract.Clocks"
				:key="clock.Id"
			>
				{{ clock.Name }} <span v-if="index != (contract.Clocks.length - 1)">,</span>
			</span>

		</td>

		<td align="center"> {{ contract.InvoiceCode }} </td>

		<td align="center">
			<b-icon font-scale="1.5" :icon="serviceClass"></b-icon>
		</td>

	</tr>
</template>
<script>
export default {
	name: "ContractListRow",

	props: ["contract"],

	computed: {
		serviceClass: function() {
			let tempClass = "x-circle";

			switch (this.contract.Status) {
				case "Active":
					tempClass = "check-circle";
					break;
				case "Paused":
					tempClass = "pause";
					break;
				case "Ended":
					tempClass = "dash-circle";
					break;
			}

			return tempClass;
		}
	},

	methods: {
		onUpdateClick() {
			this.$emit("update", this.contract.Id);
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/contract/contract-list-row.vue